import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import { formatDate } from 'utility/dateUtils';
import { EVENT_DATE_TIME_FORMAT } from '../config';
import useStyles from '../styles';

const EventDate = ({ record }) => {
  const classes = useStyles();

  return (
    <Typography variant="overline" className={classes.dateLabel}>
      {formatDate(record.created_at, EVENT_DATE_TIME_FORMAT)}
    </Typography>
  );
};

EventDate.propTypes = {
  record: PropTypes.object.isRequired,
};

export default EventDate;
